/* ════════════════════════════════════════════════════════════════════════════
   ManDana — the QR, drawn
   ----------------------------------------------------------------------------
   One component, used at both ends of every code: Settings shows one for a
   device to scan, and the door shows one for a signed-in phone to scan back.
   The encoding and the address it carries are md-qr.ts; this is only the
   picture.

   IT IS ALWAYS BLACK ON WHITE, in both themes and on the pitch-black film. A
   QR is not a decoration that should take the page's colour — it is a thing a
   camera has to read, and every camera in the world is calibrated for dark
   modules on a light plate. The white plate is drawn as part of the picture
   rather than borrowed from the surface behind it, which is also what gives it
   the four modules of quiet zone the format requires: a code that bleeds into a
   dark background scans as no code at all.

   AND IT IS NEVER THE ONLY WAY. When there is nothing to draw — no encoder, a
   string too long — this renders nothing at all and the code beside it stands
   on its own. Every surface here shows both.
   ════════════════════════════════════════════════════════════════════════════ */

/* Four modules, from the QR specification. Not a design choice. */
const MD_QR_QUIET = 4;

function MdQrCode({ text, size = 168, label = 'QR code' }) {
  const grid = window.mdQrModules ? window.mdQrModules(text) : null;
  if (!grid || !grid.length) return null;
  const d = window.mdQrPath(grid);
  if (!d) return null;

  const span = grid.length + MD_QR_QUIET * 2;
  return (
    <svg
      role="img"
      aria-label={label}
      width={size}
      height={size}
      viewBox={`${-MD_QR_QUIET} ${-MD_QR_QUIET} ${span} ${span}`}
      shapeRendering="crispEdges"
      style={{ display: 'block', borderRadius: 10, background: '#FFFFFF' }}>
      {/* The plate, in the picture's own coordinates, so the quiet zone is
          white whatever the code is sitting on. */}
      <rect x={-MD_QR_QUIET} y={-MD_QR_QUIET} width={span} height={span} fill="#FFFFFF" />
      <path d={d} fill="#000000" />
    </svg>
  );
}

Object.assign(window, { MdQrCode, MD_QR_QUIET });
